import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { useField } from 'formik';
import React from 'react';

export type SwitchFieldProps<T> = {
    field: keyof T;
    label: string;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
    style?: React.CSSProperties;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
};

export function FormikSwitch<FormStructure extends Record<string, never>>(
    props: SwitchFieldProps<FormStructure>
): JSX.Element {
    const [field, meta, helpers] = useField(props.field as string);
    const { onChange, labelPlacement, ...otherProps } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        if (props.readOnly) return;
        if (props.disabled) return;

        helpers.setValue(checked);
        helpers.setTouched(true);

        if (onChange) onChange(event, checked);
    };

    const defaultStyles = { fontWeight: 600, fontSize: 14 };
    const styleOverrides = props.style ? { ...defaultStyles, ...props.style } : defaultStyles;

    return (
        <FormControlLabel
            labelPlacement={labelPlacement}
            control={
                <Switch
                    {...otherProps}
                    checked={!!field.value || false}
                    disabled={props.disabled || props.readOnly}
                    onChange={handleChange}
                    data-test-id={`switch_${props.field}`}
                />
            }
            label={<span style={styleOverrides}>{props.label}</span>}
        />
    );
}
